import { ChevronDown } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { STATUSES, statusClass } from './adminApi';

export const StatusPill = ({ status, onChange, id }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <button type="button" className={`status-pill ${statusClass(status)}`} onClick={e => e.stopPropagation()} data-testid={`status-pill-${id}`}>
        <i aria-hidden="true" />{status || 'New'}<ChevronDown size={13} />
      </button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="start" className="status-menu" data-testid={`status-menu-${id}`}>
      {STATUSES.map(option => (
        <DropdownMenuItem key={option} onClick={e => { e.stopPropagation(); onChange(option); }} data-testid={`status-option-${id}-${option.toLowerCase()}`}>
          {option}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);
